'use strict';

function gallery() {

    if (!!$("#gal-nav").length) {

        // Add Active Class to Current Gallery
        $("#gal-nav a").each(function(index) {

            var current_url = window.location.href.replace(/^https?:\/\//, "//");
            var goLink = $(this).attr('href').replace(/^https?:\/\//, "//");

            if (current_url === goLink) {
                $(this).parent().addClass('current-menu-item current-site');
            }


        });

        var $galjax = $('#galjax');
        var $livegal = $('#live-gal');
        var $galholder = $('#galholder');

        $galjax.prepend('<div class="switch-cover"><p></p><div><b></b></div></div>');
        $galjax.prepend('<div class="status"><p></p></div>');

        //$galholder.html($('#live-gal').clone()); // store local gallery[]

        $('section#main').on('click', '#gal-nav a', function(e) {

            var home_gal = $("#gal-nav li.current-site").text();
            var this_title = $(this).text();
            var $this = $(this);
            e.preventDefault();
            var goLink = $(this).attr('href');
            $('.status').fadeOut(300);

            $("#gal-nav li").removeClass('current-menu-item');
            $this.parent().addClass('current-menu-item');

            //log(this_title + ' not ' + home_gal);
            $livegal.html('');

            // Show the loader
            $galjax.find('.switch-cover').fadeIn(300);
            $galjax.css({ 'overflow': 'hidden' });
            $galjax.css({ 'min-height': '275px' });
            $('#live-gal').css({ 'min-height': '275px' });

            // Load the Content
            setTimeout(function() {

                $livegal.on('load', `${goLink} #live-gal`, function(responseTxt, statusTxt, xhr) {
                    if (statusTxt == "success") {

                        //alert("External content loaded successfully!");
                        $('#galjax .switch-cover').fadeOut(300);
                        imagesLoaded();
                        $("html, body").animate({ scrollTop: 0 }, { duration: 900, easing: 'easeInOutExpo' });

                    }
                    if (statusTxt == "error") {
                        //alert("Error: " + xhr.status + ": " + xhr.statusText);
                        $("#gal-nav li").removeClass('current-menu-item');
                        $("#gal-nav").find('li.current-site').addClass('current-menu-item');
                        $('.status p').html(`Failed to load <b>${this_title} Gallery</b>. Defaulting to <b>${home_gal} Gallery</b>. Please try again.`);
                        $('.status').fadeIn(300);
                        setTimeout(function() { $('#galjax .switch-cover').fadeOut(300); }, 750);
                        $livegal.html($galholder.clone());
                        $("html, body").animate({ scrollTop: 0 }, { duration: 900, easing: 'easeInOutExpo' });
                    }
                });

            }, 500);

            // Trigger images loaded again after 7 seconds, just in case.
            setTimeout(function() { imagesLoaded(); }, 7000)

        });

    }


    if (!$('#gal-list').length) {
        return;
    }

    getEventsByTypeGalleries().then(function(eventTypeData) {

        $.each(eventTypeData, function(eventTypeKey, eventType) {

            var eventLogo = `<img alt="${eventType.label} Galleries" src="${eventType.logo}" width="150" class="iblock logo vc mr10 mb25">`;

            if(eventType.url) {
                eventLogo = `<a href="${eventType.url}">${eventLogo}</a>`;
            }

            var events = _.sortBy(eventType.events, 'title');

            var eventsOutput = '';
            $.each(events, function(eventKey, event) {
                if(event.galleries) {
                    eventsOutput += `<li><a data-type="${eventTypeKey}" data-event="${event.code}">${event.title}</a><span class="lbreak3"></span></li>`;
                }
            });

            var output = `
            <div class="ddevent ww ${eventTypeKey}">
                <div class="ddhead">
                    ${eventLogo}
                    <img alt="" src="${eventType.accent}" width="15" class="iblock accent vc mb25">
                    <div class="lbreak3 op50"></div>
                </div>
                <ul class="glinks">
                    ${eventsOutput}
                </ul>
            </div>`;

            $('.event-selector').append(output);
        });

        $('.events-toggle').on('click', function(){
            $(this).toggleClass('active');
            $('.esdd').fadeToggle(300);
        });

        $(document).on('click', '.ddevent a[data-event]', function(){

            var el = $(this);
            var code = el.data('event');
            var type = el.data('type');

            var eventType = eventTypeData[type];
            var event = _.find(eventType.events, { 'code': code });

            $('.ddevent li.active').removeClass('active');
            el.parent().addClass('active');
            $('#active-gal').attr('data-code', code);

            var galleryYearOutput = '';
            $.each(event.galleries, function(galleryKey, gallery) {
                var galleryLogo = gallery.logo ? gallery.logo : event.appdata.logo;

                galleryYearOutput += `<li><a data-logo="${galleryLogo}" data-type="${type}" data-event="${gallery.code}" data-year="${gallery.name}">${gallery.name}</a></li>`;
            });

            $('div.year-nav ul').html(galleryYearOutput);

            // Select active year or default it
            var activeYear = $('#active-gal').attr('data-year');
            var activeYearButton = $(`div.year-nav a[data-year="${activeYear}"]`);

            if ( !activeYearButton.length ) {
                activeYearButton = $('div.year-nav ul li:first-child a');
            }

            activeYearButton.trigger('click');

            // Close Event List
            $('.events-toggle.active').trigger('click');

        });


        $(document).on('click', '.year-nav a[data-event]', function(){
            var el = $(this);
            var type = el.data('type');
            var code = el.data('event');
            var logo = el.data('logo');
            var year = el.data('year').toString();

            var eventType = eventTypeData[type];
            var event = _.find(eventType.events, { 'code': code });
            var gallery = _.find(event.galleries, { 'name': year });

            $('.year-nav a.active').removeClass('active');
            el.addClass('active');

            var logo = `<a href="${event.url}" target="_blank" class="mb20 iblock"><img alt="${event.title_label}" src="${logo}" style="height:50px !important;"></a>`;
            $('#active-gal')
                .html(logo)
                .attr('data-year', year);
            $('#gtt').html( `${event.title_label} ${year} Event Photos`);

            var output = '';

            $.each(gallery.featured, function(k, v) {
                var alttext = '';
                if ( k < 1 ) {
                    alttext = `${eventType.label} ${event.title} ${year} Featured Event Photos`;
                }
                output += `
                <li>
                    <a class="loading" data-fancybox="gallery" href="${v.image}" style="background-image: url(${v.thumb})">
                        <b></b>
                        <figure role="group" aria-labelledby="gtt"><img alt="${alttext}" src="${v.image}"></figure>
                        <span></span>
                    </a>
                </li>`;
            });

            $.each(gallery.images, function(k, v) {
                var alttext = '';
                if ( k < 1 ) {
                    alttext = `${event.title_label} ${year} Event Photos`;
                }
                output += `
                <li>
                    <a class="loading" data-fancybox="gallery" href="${v.image}" style="background-image: url(${v.thumb})">
                        <b></b>
                        <figure role="group" aria-labelledby="gtt"><img alt="${alttext}" src="${v.image}"></figure>
                        <span></span>
                    </a>
                </li>`;
            });

            $('#gal-list ul').html(output);

            imagesLoaded();
            lightboxes();
            setTimeout(function() { imagesLoaded(); }, 7500);

        });

        var gevent = $('#event-gal').data('gevent');
        var gyear = $('#event-gal').data('gyear');
        var gtype = $('#event-gal').data('gtype');

        var type = _.findKey(eventTypeData, { 'type': gtype });

        $(`.ddevent a[data-event="${gevent}"][data-type="${type}"]`).trigger('click');
        $(`.year-nav a[data-year="${gyear}"]`).trigger('click');
    });
}
